import { Injectable, computed, signal } from '@angular/core';
import { DynamicHeaderComponent } from 'src/app/components/dynamic-header/dynamic-header.component';

@Injectable({
  providedIn: 'root'
})
export class CommunicationService {

  private _dynamicHeaderComponent = signal<DynamicHeaderComponent | null>(null);
  readonly headerRef = this._dynamicHeaderComponent.asReadonly();

  private _stickyHeader = signal<boolean>(true);
  readonly stickyHeader = this._stickyHeader.asReadonly();

  // Computed signals for derived state
  readonly hasHeaderRef = computed(() => !!this._dynamicHeaderComponent());
  readonly isHeaderSticky = computed(() => this._stickyHeader());

  setHeaderRef(header: DynamicHeaderComponent) {
    this._dynamicHeaderComponent.set(header);
  }

  setHeaderPosition(sticky: boolean) {
    this._stickyHeader.set(sticky);
  }
}
